// A class's announcements (byj-1wv.135): what its instructor posted to the
// class, newest first, on its page for its students whenever they come — the
// note to live sessions alone reached none of an exam's students — and, for
// the instructor, each with a way to take it down.
import type { Announcement } from "../api";
import { ago, t, whenMinute } from "../i18n";

export function Announcements({ items, onDelete, now }: { items: Announcement[]; onDelete?: (a: Announcement) => void; now?: number }) {
  if (items.length === 0) return null;
  return (
    <section className="card announcements" aria-labelledby="announcements-title" data-testid="announcements">
      <h3 id="announcements-title" className="rows-head">
        {t("classes:announcementsTitle")} · {items.length}
      </h3>
      <ul className="flush">
        {items.map((a) => (
          <li key={a.id} className="announcement" data-testid="announcement">
            <p className="announcement-text flush">{a.text}</p>
            <div className="row wrap muted small">
              <span title={whenMinute(a.created_at)}>{t("classes:announcedBy", { name: a.author.name || t("classes:theInstructor"), when: ago(a.created_at, now) })}</span>
              {onDelete && (
                <>
                  <span className="grow" />
                  <button className="small" onClick={() => onDelete(a)}>
                    {t("classes:deleteAnnouncement")}
                  </button>
                </>
              )}
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
